var _a;
export var FolderCardSize;
(function (FolderCardSize) {
    FolderCardSize["NANO"] = "nano";
    FolderCardSize["TINY"] = "tiny";
    FolderCardSize["SMALL"] = "small";
    FolderCardSize["MEDIUM"] = "medium";
    FolderCardSize["BIG"] = "big";
})(FolderCardSize || (FolderCardSize = {}));
export var folderCardSizeBreakpoints = (_a = {},
    _a[FolderCardSize.NANO] = 130,
    _a[FolderCardSize.TINY] = 220,
    _a[FolderCardSize.MEDIUM] = 300,
    _a[FolderCardSize.BIG] = 999,
    _a);
//# sourceMappingURL=consts.js.map